import type { Order } from '@ztechapps/common.contract'
import { formatMoney } from '@ztechapps/common.utils'

export function isBelowMinimumOrderAmount(order?: Order): boolean {
  const minimumOrderAmount = order?.minimumOrderAmount ?? 0
  const gross = order?.gross ?? 0

  return minimumOrderAmount > 0 && gross < minimumOrderAmount
}

/**
 * How much the items subtotal still has to grow to reach the order's own minimum. Zero or
 * negative once the minimum is met, so read it only alongside `isBelowMinimumOrderAmount`.
 */
export const minimumOrderAmountShortfall = (order?: Order): number =>
  (order?.minimumOrderAmount ?? 0) - (order?.gross ?? 0)

/**
 * The minimum-order block message, naming the minimum and the exact shortfall. A builder rather
 * than a const because both amounts are per-order. Wording matches the storefront's
 * `MinimumOrderAmountNote` so the server rejection reads the same as the note the customer saw.
 */
export const belowMinimumOrderAmountPaymentBlockMessage = (order?: Order): string => {
  const minimumOrderAmount = order?.minimumOrderAmount ?? 0

  return `A minimum order of ${formatMoney(minimumOrderAmount)} is required to checkout. Add ${formatMoney(minimumOrderAmountShortfall(order))} more to reach it.`
}
